import { connect } from 'react-redux';
import { get } from 'lodash';
import EditPortfolioModal, {
  EditPortfolioModalProps,
} from '@/components/DeprecatedPortfolio/components/EditPortfolioModal';
import {
  editPortfolio,
  EditPortfolioPayload,
  HideEditPortfolioModal,
} from '@/components/DeprecatedPortfolio/components/EditPortfolioModal/redux';
import {
  portfolioSelector,
  portfolioSummarySelector,
} from '@/components/DeprecatedPortfolio/redux/selectors';
import type { PortfolioState } from '@/components/DeprecatedPortfolio/redux/interface';
import type { State as PortfoliosState } from '@/components/DeprecatedPortfolios/redux/reducers';

const getter = (obj) => (property, defaultValue) =>
  get(obj, property, defaultValue);

const mapStateToProps = (state): Partial<EditPortfolioModalProps> => {
  const {
    portfolio: {
      editPortfolioModal: { editStatus, editPortfolioModalStatus },
    },
    portfolios,
  }: {
    portfolio: PortfolioState;
    portfolios: PortfoliosState;
  } = state;
  const portfolio = portfolioSelector(state);
  const portfolioGetter = getter(portfolio);
  const portfolioSummary = portfolioSummarySelector(state);
  const summaryGetter = getter(portfolioSummary);
  return {
    portfolioId: portfolioGetter('id', null),
    portfolioName: portfolioGetter('name', ''),
    currencyISO: summaryGetter('currencyISO', 'USD'),
    isUpdating: editStatus === 'updating',
    portfolioKeys: portfolios.userKeys,
    portfolioEntities: portfolios.entities,
    editPortfolioModalStatus,
  };
};

const mapDispatchToProps = (dispatch): Partial<EditPortfolioModalProps> => {
  return {
    onSubmit: (data: EditPortfolioPayload) => dispatch(editPortfolio(data)),
    onClose: () => dispatch(HideEditPortfolioModal.trigger()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditPortfolioModal);
